/** Les evenements : liste, fiche, creation, gestion. */
export const sorties = {
  erreurs: {
    introuvable: 'Événement introuvable',
    titre: 'Donne un titre à ton événement',
    lieu: 'Indique un lieu de rendez-vous',
    adresse: 'Choisis une adresse dans la liste proposée',
    horsZone: 'Choisis une adresse dans le pays de ce spot.',
    lien: 'Ce lien ne mène nulle part : vérifie-le, ou laisse le champ vide',
    dateInvalide: 'Choisis une date valide',
    datePassee: 'La date est déjà passée',
    heureDebut: "Indique l'heure de début",
    heureFin: "Indique l'heure de fin",
    finDifferente: "L'heure de fin doit être différente de l'heure de début",
    passe: {
      inscrire: 'on ne peut plus s’y inscrire',
      valider: 'les demandes ne se valident plus',
      modifier: 'il ne se modifie plus',
      figee: 'sa liste de participants est figée',
      retirer: 'on ne peut plus s’en retirer',
      reprendre: 'il n’y a plus rien à reprendre',
      supprimer: 'il ne peut plus être supprimé',
    },
    annuleFaute: 'Cet événement a été annulé faute de participants',
    complet: "Toutes les places sont prises, libère-en une avant d'accepter",
    pasInscrite: "Cette personne n'est pas inscrite à cet événement",
    feuillePasFinie: "La feuille se vérifie une fois l'événement terminé",
    feuilleValidee: 'Cette feuille a déjà été validée',
    note: 'Une note va de 1 à 5',
    finApresDebut: "L'heure de fin doit suivre celle de début",
    tropTard: 'Cet événement commence dans moins de dix heures : il ne se modifie plus',
    creneauPasse: 'Ce créneau est déjà passé',
    organisateurReste: "Tu organises cet événement, tu ne peux pas t'en retirer",
    sansGroupe: "Cette sortie n'a pas de groupe",
    seulOrganisateur: "Seul l'organisateur gère les participants",
    organisateurPart: 'Tu organises cet événement : passe la main ou supprime-le',
    autreQuelquun: "Choisis quelqu'un d'autre pour reprendre l'événement",
    neParticipePas: "Cette personne ne participe pas à l'événement",
    nombreParticipants: (min: number, max: number) => `Le nombre de participants doit être compris entre ${min} et ${max}`,
    suspendu: (jusqua: number) =>
    `Tu as manqué deux événements sans prévenir : tu pourras t'inscrire à nouveau le ${new Date(jusqua).toLocaleDateString('fr-FR')}`,
    estPasse: (raison: string) => `Cet événement est passé : ${raison}`,
    creneauPris: (titre: string) => `Tu es déjà pris sur ce créneau, par « ${titre} »`,
  },
  carte: {
    inscrit: 'Inscrit(e)',
    enAttente: 'En attente',
    complet: 'Complet',
    note: (note: string) => `Organisateur/trice noté ${note} sur 5`,
    participants: (n: number, max: number) => `${n}/${max} participants`,
  },
  commun: {
    autresActions: 'Autres actions',
    lieu: 'Lieu',
    date: 'Date',
    participants: 'Participants',
    monBillet: 'Mon billet',
    enLigne: 'En ligne',
    masquerQ: 'Masquer cet événement ?',
    masquer: 'Masquer cet événement',
    actionImpossible: 'Action impossible pour le moment.',
  },
  fiche: {
    noteNonEnvoyee: "Cette note n'a pas pu être envoyée.",
    groupeImpossible: 'Impossible d’ouvrir le groupe',
    ecrireImpossible: 'Impossible de lui écrire pour le moment.',
    desinscrireQ: 'Te désinscrire de cet événement ?',
    titre: 'Événement',
    adresseComplete: 'Adresse complète',
    partager: 'Partager l’événement',
    retirerMasques: 'Retirer des masqués',
    presenceEnregistree: 'Ta présence a été enregistrée.',
    montreLeCarre: 'Montre ce carré à l’organisateur/trice en arrivant : il confirme ta présence.',
    passe: 'Cet événement est passé',
    gerer: 'Gérer mon événement',
    rejoindreGroupe: 'Rejoindre le groupe',
    groupe: 'Le groupe de la sortie',
    monAgenda: 'Mon agenda',
    presenceConfirmee: 'Présence confirmée',
    horaire: 'Horaire',
    places: 'Places',
    lien: 'Lien',
    lienApresInscription: 'Après inscription',
    rejoindre: (hote: string) => `Rejoindre sur ${hote}`,
    noteOrganisateur: 'Note l’organisateur/trice',
    commentCaSEstPasse: 'Comment s’est passé cet événement ?',
    noteSurCinq: 'Note sur 5',
    langues: 'Langues',
    description: 'Description',
    organise: 'Organise',
    prevenir: 'Préviens l’organisateur/trice si tu ne peux plus venir. Deux absences ferment l’inscription aux événements pendant une semaine.',
    autresApresAcceptation: "Les autres participants s'affichent une fois ta participation acceptée.",
    annulerDemande: 'Annuler ma demande',
    meDesinscrire: 'Je me désinscris',
    listeAttente: 'Rejoindre la liste d’attente',
    demanderAParticiper: 'Demander à participer',
    participer: 'Participer',
    gererDemandes: (n: number) => `Gérer · ${n} demande${n > 1 ? 's' : ''}`,
    suspendu: (jusqua: number) =>
    `Deux absences : inscription possible le ${new Date(jusqua).toLocaleDateString('fr-FR')}`,
    organisePar: (nom: string) => `Organisé par ${nom}`,
    ecrireA: (nom: string) => `Écrire à ${nom}`,
    noteAide: (nom: string) => `Note ${nom}. Une note donnée ne se reprend pas.`,
    surCinq: (n: number) => `${n} sur 5`,
    donnerQ: (n: number, nom: string) =>
    `Donner ${n} étoile${n > 1 ? 's' : ''} à ${nom} ? Cette note est définitive.`,
    demandesEnAttente: (n: number) => `${n} demande${n > 1 ? 's' : ''} en attente de ta réponse.`,
  },
  gestion: {
    groupeImpossible: 'Création du groupe impossible.',
    passationImpossible: 'Passation impossible pour le moment.',
    feuilleTousLa: 'Feuille validée. Tout le monde était là.',
    validationImpossible: 'Validation impossible pour le moment.',
    scan: {
      pasSirocco: 'Ce carré ne vient pas de Sirocco.',
      autreSortie: 'Ce billet est celui d’un autre événement.',
      pasInscrite: 'Cette personne n’est pas inscrite ici.',
      impossible: 'Enregistrement impossible.',
      dejaPresent: (nom: string) => `${nom} est déjà noté présent.`,
      present: (nom: string) => `${nom} · présent`,
    },
    suppressionImpossible: 'Suppression impossible pour le moment.',
    quitter: "Quitter l'événement",
    supprimerQ: "Supprimer l'événement ?",
    supprimer: "Supprimer l'événement",
    aQui: 'À qui laisses-tu l’organisation ?',
    modifier: 'Modifier l’événement',
    scanner: 'Scanner les billets',
    reserve: "Réservé à l'organisateur/trice",
    reserveAide: 'Seule la personne qui organise cet événement peut gérer ses participants.',
    tropTard: 'Trop tard pour modifier : l’événement commence dans moins de dix heures.',
    scannerUn: 'Scanner un billet',
    ouvrirGroupe: 'Ouvrir le groupe',
    creerGroupe: 'Créer le groupe',
    personneAReunir: 'Personne à réunir',
    demandes: 'Demandes',
    feuilleAVerifier: 'Feuille de présence à vérifier',
    feuilleAide: 'Ouvre les participants, coche celles et ceux qui sont venus, puis valide. Les autres seront comptés absents, deux absences ferment l’inscription d’un membre pendant une semaine.',
    validerTousQ: 'Valider la feuille ? Tout le monde est noté présent.',
    valider: 'Valider la feuille',
    modificationImpossible: 'Modification impossible.',
    champs: {
      titre: 'Titre',
      debut: 'Début',
      fin: 'Fin',
    },
    placesGardees: 'Les participants déjà inscrits gardent leur place. Le nombre de places ne se modifie pas.',
    enregistrer: 'Enregistrer',
    ouvertureCamera: 'Ouverture de la caméra…',
    feuilleAbsents: (n: number) =>
    `Feuille validée. ${n} absence${n > 1 ? 's' : ''} enregistrée${n > 1 ? 's' : ''}.`,
    laisserQ: (nom: string) => `Laisser l'organisation à ${nom} ?`,
    valideeLe: (date: string) => `Feuille validée le ${date}`,
    validerQ: (n: number) =>
    `Valider la feuille ? ${n} personne${n > 1 ? 's seront comptées absentes' : ' sera comptée absente'}.`,
  },
  categories: {
    sport: 'Sport',
    culture: 'Culture',
    pro: 'Pro',
    food: 'Food',
    asso: 'Asso',
    etudes: 'Études',
    jeux: 'Jeux',
  },
  reserve: {
    titre: "Réservé à l'organisateur/trice",
  },
  creation: {
    impossible: 'Publication impossible',
    titreSortie: 'Proposer une sortie',
    titreEvenement: 'Créer un événement',
    publierSortie: 'Publier la sortie',
    publierEvenement: "Publier l'événement",
    type: 'Type de sortie',
    evenement: 'Événement',
    spontanee: 'Spontanée',
    enLigne: 'En ligne',
    affiche: 'Affiche (facultative)',
    choisirAffiche: 'Choisir une affiche',
    retirerAffiche: "Retirer l'affiche",
    quoi: 'Quoi ?',
    titre: 'Titre',
    exempleSortie: 'Café au Clock',
    exempleEvenement: 'Football 5v5',
    categorie: 'Catégorie',
    horaires: 'Horaires',
    heureDebut: 'Heure de début',
    heureFin: 'Heure de fin',
    ouSurLeCampus: 'Où sur le campus ? Amphi, salle, terrain…',
    campusAile: (aile: string): string => (aile.length <= 2 ? `Aile ${aile}` : aile),
    campusEtage: (n: number): string => (n === 0 ? 'rez-de-chaussée' : n === 1 ? '1er étage' : `${n}e étage`),
    chercheAdresse: 'Cherche une adresse',
    lien: 'Lien de connexion (facultatif)',
    lienExemple: 'https://zoom.us/j/…',
    lienAide: 'Une visio, un salon Discord… Seuls les inscrits le verront dans la fiche.',
    placeSurLePlan: 'Placé sur le plan, touche pour le déplacer',
    placerSurLePlanBouton: 'Placer sur le plan du campus',
    annuaireMuet: "L'annuaire d'adresses ne répond pas. Réessaie dans un instant.",
    aucuneAdresse: 'Aucune adresse trouvée. Précise la rue ou le nom du lieu.',
    nombreParticipants: 'Nombre de participants',
    maximum: 'Maximum',
    retirerPlace: 'Retirer une place',
    ajouterPlace: 'Ajouter une place',
    seConfirme: 'Se confirme à partir de',
    abaisserSeuil: 'Abaisser le seuil',
    aucun: 'Aucun',
    releverSeuil: 'Relever le seuil',
    description: 'Description',
    descriptionExemple: "Ce qu'il faut savoir : niveau, matériel, point de rendez-vous...",
    validation: 'Validation des participants',
    langues: 'Langue parlée',
    languesTitre: 'Langues parlées',
    languesMax: 'Trois langues au maximum.',
    languesChercher: 'Chercher une langue',
    languesAucune: 'Aucune langue ne correspond.',
    languesTermine: 'Terminé',
    languesNoms: { ary: 'Arabe marocain', zgh: 'Amazighe' },
  },
  filtres: {
    titre: 'Filtres d’événements',
    quand: 'Quand',
    du: 'Du',
    aPartirDu: 'À partir du',
    au: 'au',
    jusquAu: "Jusqu'au",
    distance: 'Distance',
    rayon: 'Rayon autour de moi',
    sansDistance: 'Aucune distance demandée',
    sansPosition: 'Position introuvable. Le filtre de distance a besoin de ta localisation.',
    nature: 'Nature',
    spontanees: 'Sorties spontanées',
    enLigne: 'En ligne',
    categories: 'Catégories',
    langues: 'Langues',
    toutesLangues: 'Toutes les langues',
    appliquer: 'Appliquer les filtres',
    effacer: 'Effacer',
    kilometres: (n: number) => `${n} kilomètres`,
  },
  liste: {
    rechercher: 'Rechercher...',
    carte: 'Carte des événements',
    agenda: 'Mon agenda',
    creer: 'Créer un événement',
    masques: 'Événements masqués',
    filtreActif: 'Filtrer · un filtre est actif',
    filtrer: 'Filtrer',
    unSansAdresse: '1 sortie sans adresse précise n’est pas comptée dans ce rayon.',
    aucun: 'Aucun événement',
    elargir: 'Essaie d’élargir tes catégories.',
    personne: 'Personne n’a encore proposé de sortie ici.',
    proposer: 'Proposer une sortie',
    pourToi: 'Pour toi',
    toutes: 'Toutes les sorties',
    sansAdresse: (n: number) => `${n} sorties sans adresse précise ne sont pas comptées dans ce rayon.`,
    rienAMoinsDe: (km: number) => `Rien à moins de ${km} km de toi. Essaie un rayon plus large.`,
  },
  agenda: {
    onglets: {
      aVenir: 'À venir',
      jOrganise: "J'organise",
    },
    titre: 'Mon agenda',
    semaine: 'CETTE SEMAINE',
    plusTard: 'PLUS TARD',
    rien: 'Rien à afficher ici',
    rienAide: 'Inscris-toi à une sortie, ou propose la tienne : elle apparaîtra ici.',
    rienOrganise: 'Les événements que tu organises apparaîtront ici.',
    voir: 'Voir les événements',
    proposer: 'Proposer une sortie',
  },
  participants: {
    titre: 'Participants',
    reserveAide: 'Seule la personne qui organise cet événement peut voir cette liste.',
    chercher: 'Chercher un participant',
    personne: 'Personne de ce nom dans cet événement.',
    present: 'Présent(e)',
    organise: 'Organise',
    absent: 'Absent(e)',
    retirerQ: (nom: string) => `Retirer ${nom} de l'événement ?`,
    retirerPresence: (nom: string) => `Retirer la présence de ${nom}`,
    estLa: (nom: string) => `${nom} est là`,
  },
  demandes: {
    titre: 'Demandes',
    reserveAide: 'Seule la personne qui organise cet événement peut traiter ses demandes.',
    chercher: 'Chercher une demande',
    personne: 'Personne de ce nom dans les demandes.',
    aucune: 'Aucune demande',
    aucuneAide: 'Les demandes de participation arriveront ici.',
    ouvert: "Cet événement accepte tout le monde d'office, tant qu'il reste de la place.",
    rang: (rang: number) => `${rang}${rang === 1 ? 're' : 'e'} de la liste`,
    accepter: (nom: string) => `Accepter ${nom}`,
    refuser: (nom: string) => `Refuser ${nom}`,
  },
  miennes: {
    onglets: {
      inscrit: 'Inscrit',
      organise: 'Organisé',
      passes: 'Passés',
    },
    vides: {
      inscrit: 'Tes inscriptions apparaîtront ici.',
      organise: 'Les événements que tu organises apparaîtront ici.',
      passes: 'Les événements où ta présence a été confirmée apparaîtront ici.',
    },
    titre: 'Mes événements et sorties',
    uneFeuille: 'Une feuille de présence à vérifier',
    rien: 'Rien à afficher ici',
    feuilles: (n: number) => `${n} feuilles de présence à vérifier`,
  },
  masques: {
    titre: 'Événements masqués',
    aucun: 'Aucun événement masqué',
    aucunAide: 'Ceux que tu masques depuis leur fiche atterrissent ici.',
    remettre: 'Ouvre un événement pour le remettre dans tes listes.',
  },
};
